import type { PluginDefaultTranslationsObject, PluginLanguage } from '../types.js'

export const rsLatinTranslations: PluginDefaultTranslationsObject = {
  $schema: './translation-schema.json',
  'plugin-form-builder': {
    name: 'Ime (mala slova, bez posebnih znakova)',
    add: 'Dodaj',
    allowedFileTypes: 'Dozvoljeni tipovi datoteka',
    allowedFileTypesDescription:
      'Ograničite dozvoljene tipove datoteka (npr. slika/*, aplikacija/pdf). Ostavite prazno da biste dozvolili sve vrste.',
    allowMultipleFiles: 'Dozvoli više datoteka',
    amountInCents: 'Iznos u centima',
    basePrice: 'Osnovna cena',
    bcc: 'BCC',
    brand: 'Brand',
    cc: 'CC',
    checkboxPlural: 'Polja za potvrdu',
    checkboxSingular: 'Polje za potvrdu',
    checkedByDefault: 'Podrazumevano označeno',
    chooseConfirmationType:
      'Odaberite da li želite da prikažete poruku na stranici ili da preusmerite na drugu stranicu nakon što pošalju obrazac.',
    condition: 'Stanje',
    confirmationMessage: 'Poruka za potvrdu',
    confirmationType: 'Vrsta potvrde',
    countryPlural: 'Countri Fields',
    countrySingular: 'Država',
    creditCard: 'Kreditna kartica',
    customURL: 'Prilagođeni URL',
    datePlural: 'Polja datuma',
    dateSingular: 'Datum',
    defaultValue: 'Podrazumevana vrednost',
    divide: 'Divide',
    documentToLinkTo: 'Dokument za povezivanje',
    doesNotEqual: 'Nije jednako',
    emailFrom: 'Email From',
    emailPlural: 'Polja e-pošte',
    emailsDescription:
      'Pošaljite prilagođene imejlove kada se obrazac pošalje. Koristite liste razdvojene zarezima da pošaljete istu e-poštu većem broju primalaca. Da biste referencirali vrednost iz ovog obrasca, umotajte ime tog polja dvostrukim vitičastim zagradama, tj. {{firstName}}. Možete da koristite džoker znak {{*}} za izlaz svih podataka i {{*:table}} da ih formatirate kao HTML tabelu u e-poruci.',
    emailSingular: 'Email',
    emailTo: 'Email To',
    equals: 'Jednako',
    field: 'Polje',
    fields: 'Polja',
    fieldWidth: 'Širina polja (procenat)',
    hasAnyValue: 'Ima bilo kakvu vrednost',
    internalLink: 'Interna veza',
    label: 'Label',
    maxFileSize: 'Maksimalna veličina datoteke (bajtovi)',
    maxFileSizeDescription:
      'Maksimalna veličina datoteke u bajtovima. Ostavite prazno bez ograničenja.',
    message: 'Poruka',
    messageDescription: 'Unesite poruku koju treba poslati u ovoj e-poruci.',
    messagePlural: 'Blokovi poruka',
    messageSingular: 'Poruka',
    mimeType: 'MIME Tipe',
    mimeTypePlural: 'MIME tipovi',
    mimeTypeSingular: 'MIME Tipe',
    multiply: 'Pomnožite',
    numberPlural: 'Number Fields',
    numberSingular: 'Broj',
    optionPlural: 'Opcije',
    optionSingular: 'Opcija',
    paymentFieldPlural: 'Polja za plaćanje',
    paymentFieldSingular: 'Plaćanje',
    paymentProcessor: 'Procesor plaćanja',
    paymentStatus: 'Status',
    placeholder: 'Čuvar mesta',
    priceConditions: 'Uslovi cene',
    priceConditionsPlural: 'Uslovi cene',
    priceConditionsSingular: 'Price Condition',
    radioOptions: 'Opcije radio atributa',
    radioPlural: 'Radio Fields',
    radioSingular: 'Radio',
    redirect: 'Preusmeri',
    replyTo: 'Odgovori na',
    required: 'Obavezno',
    selectOptions: 'Izaberite Opcije',
    selectPlural: 'Izaberite Polja',
    selectSingular: 'Izaberite',
    statePlural: 'State Fields',
    stateSingular: 'Država',
    staticValue: 'Statička vrednost',
    subject: 'Predmet',
    submitButton: 'Pošalji oznaku dugmeta',
    subtract: 'Oduzmi',
    textareaPlural: 'Tektarea Fields',
    textareaSingular: 'Tektarea',
    textPlural: 'Tekt Fields',
    textSingular: 'Tekst',
    title: 'Naslov',
    token: 'token',
    uploadCollection: 'Otpremi kolekciju',
    uploadCollectionDescription:
      'Izaberite kolekciju za otpremanje u koju ćete skladištiti datoteke',
    uploadFieldPlural: 'Upload Fields',
    uploadFieldSingular: 'Upload',
    urlToRedirectTo: 'URL za preusmeravanje',
    value: 'Value',
    valueOfField: 'Vrednost polja',
    valueType: 'Vrsta vrednosti',
  },
}

export const rsLatin: PluginLanguage = {
  dateFNSKey: 'rs-Latin',
  translations: rsLatinTranslations,
}
